import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, Teleport as _Teleport, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "w-full mt-4 flex flex-col gap-4" }
const _hoisted_2 = { class: "overflow-x-auto rounded-lg shadow-sm border border-gray-200 min-h-[300px]" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"hidden md:grid grid-cols-12 gap-1 w-full items-center px-4 py-2 text-sm text-gray-500 font-semibold\" style=\"background:var(--Neutral-LightGray-5, #fafafa);\"><div class=\"col-span-3\"><p class=\"text-start\">Nome</p></div><div class=\"col-span-3\"><p class=\"text-start\">Email</p></div><div class=\"col-span-2\"><p class=\"text-start\">Empresa</p></div><div class=\"col-span-3\"><p class=\"text-start\">Usuários</p></div><div class=\"col-span-1\"><p class=\"text-end\">Ações</p></div></div>", 1)
const _hoisted_4 = { class: "hidden md:block md:col-span-3" }
const _hoisted_5 = { class: "text-start" }
const _hoisted_6 = { class: "hidden md:block md:col-span-3 break-words" }
const _hoisted_7 = { class: "text-sm text-start" }
const _hoisted_8 = { class: "hidden md:block md:col-span-2" }
const _hoisted_9 = { class: "text-start" }
const _hoisted_10 = { class: "hidden md:block md:col-span-3" }
const _hoisted_11 = { class: "hidden md:flex md:col-span-1 gap-2 items-center justify-end" }
const _hoisted_12 = { class: "flex flex-col gap-2 md:hidden col-span-12" }
const _hoisted_13 = { class: "font-medium" }
const _hoisted_14 = { class: "text-sm text-gray-500 break-words" }
const _hoisted_15 = { class: "text-sm" }
const _hoisted_16 = { class: "flex gap-2 items-center pt-1" }
const _hoisted_17 = {
  key: 0,
  class: "flex justify-center py-2"
}

import { onMounted, computed, watch } from 'vue'
import { mdiPencil, mdiTrashCan, mdiShieldAccount } from '@mdi/js'
import { useGroupStore } from '@/pinia-store/useGroupStore'
import { storeToRefs } from 'pinia'
import { ref } from 'vue'
import { useToast } from 'vue-toastification'
import ConfirmDeleteModal from '@/components/designSystem/modals/confirm.delete.action.vue'
import TableChips from '@/components/designSystem/Chips/TableChips.vue'
import GroupTableSkeleton from '@/components/designSystem/Skeleton/GroupTableSkeleton.vue'
import EmptyList from '@/components/EmptyList.vue'
import { useErrorToast } from '@/composables/useErrorToast'
import { GroupResponse } from '@/Network/Types/Responses/GroupResponses'
import { EModals, useModalStore } from '@/pinia-store/useModalStore'
import UpdateGroupModal from './modal/update.group.modal.vue'
import { AuthorizationResourcesAndSubjects } from '@/types/authorization'


export default /*#__PURE__*/_defineComponent({
  __name: 'group.tab',
  setup(__props) {

const groupStore = useGroupStore()
const { filteredGroups, isLoading } = storeToRefs(groupStore)
const isLoadingDelete = ref(false)
const showDeleteModal = ref(false)
const groupToDelete = ref<{ name: string; id: number }>({ id: 0, name: '' })
const groupToUpdate = ref<GroupResponse | undefined>(undefined)
const toast = useToast()
const { notifyError } = useErrorToast()

const currentPage = ref(1)
const itemsPerPage = ref(8)

const paginatedGroups = computed(() => {
  const start = (currentPage.value - 1) * itemsPerPage.value
  return filteredGroups.value.slice(start, start + itemsPerPage.value)
})

const pageCount = computed(() => Math.ceil(filteredGroups.value.length / itemsPerPage.value))

const changePage = (page: number) => {
  currentPage.value = page
}

watch(
  () => filteredGroups.value.length,
  () => {
    currentPage.value = 1
  }
)

onMounted(async () => {
  try {
    await groupStore.getAllGroups()
  } catch (error) {
    notifyError(error, 'Não foi possível carregar os grupos.')
  }
})

const openModalDelete = (id: number, name: string) => {
  showDeleteModal.value = true
  groupToDelete.value.id = id
  groupToDelete.value.name = name
}

const handleDelete = async () => {
  try {
    isLoadingDelete.value = true
    await groupStore.remove(groupToDelete.value.id)
    toast.success('Grupo removido com sucesso!')
    await groupStore.getAllGroups()
  } catch (error) {
    notifyError(error, 'Não foi possível excluir o grupo.')
  } finally {
    showDeleteModal.value = false
    isLoadingDelete.value = false
    groupToDelete.value = {
      id: 0,
      name: ''
    }
  }
}

const modalStore = useModalStore()
const openModalUpdate = (group: GroupResponse) => {
  groupToUpdate.value = group
  modalStore.toggleModal(EModals.UPDATE_GROUP_MODAL)
}

const openPermissionsModal = (group: GroupResponse) => {
  modalStore.toggleModal(EModals.PERMISSIONS_TREE, {
    subjectId: group.id,
    subjectType: AuthorizationResourcesAndSubjects.Group,
    subjectName: group.name
  })
}

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_pagination = _resolveComponent("v-pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(isLoading))
      ? (_openBlock(), _createBlock(GroupTableSkeleton, { key: 0 }))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            (_unref(filteredGroups).length > 0)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(paginatedGroups.value, (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: item.id,
                    class: "grid grid-cols-12 gap-1 w-full items-center px-4 py-3 border-b border-gray-100 hover:bg-gray-50 text-gray-600"
                  }, [
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("p", _hoisted_5, _toDisplayString(item.name), 1)
                    ]),
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("p", _hoisted_7, _toDisplayString(item.email), 1)
                    ]),
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("p", _hoisted_9, _toDisplayString(item.company.name), 1)
                    ]),
                    _createElementVNode("div", _hoisted_10, [
                      _createVNode(TableChips, {
                        items: item.userGroups.map(({ user }) => ({ id: user.id, name: user.name }))
                      }, null, 8, ["items"])
                    ]),
                    _createElementVNode("div", _hoisted_11, [
                      _createVNode(_component_v_icon, {
                        "data-testid": "edit-group-button",
                        onClick: ($event: any) => (openModalUpdate(item)),
                        class: "hover:cursor-pointer",
                        color: "primary",
                        size: "small",
                        icon: _unref(mdiPencil)
                      }, null, 8, ["onClick", "icon"]),
                      _createVNode(_component_v_icon, {
                        "data-testid": "delete-group-button",
                        onClick: ($event: any) => (openModalDelete(item.id, item.name)),
                        class: "hover:cursor-pointer",
                        color: "primary",
                        size: "small",
                        icon: _unref(mdiTrashCan)
                      }, null, 8, ["onClick", "icon"]),
                      _createVNode(_component_v_tooltip, { text: "Visualizar permissões" }, {
                        activator: _withCtx(({ props: tooltipProps }) => [
                          _createVNode(_component_v_icon, _mergeProps(tooltipProps, {
                            "data-testid": "permissions-group-button",
                            onClick: ($event: any) => (openPermissionsModal(item)),
                            class: "hover:cursor-pointer",
                            color: "primary",
                            size: "small",
                            icon: _unref(mdiShieldAccount)
                          }), null, 16, ["onClick", "icon"])
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("p", _hoisted_13, _toDisplayString(item.name), 1),
                      _createElementVNode("p", _hoisted_14, _toDisplayString(item.email), 1),
                      _createElementVNode("p", _hoisted_15, _toDisplayString(item.company.name), 1),
                      _createVNode(TableChips, {
                        items: item.userGroups.map(({ user }) => ({ id: user.id, name: user.name }))
                      }, null, 8, ["items"]),
                      _createElementVNode("div", _hoisted_16, [
                        _createVNode(_component_v_icon, {
                          onClick: ($event: any) => (openModalUpdate(item)),
                          class: "hover:cursor-pointer",
                          color: "primary",
                          size: "small",
                          icon: _unref(mdiPencil)
                        }, null, 8, ["onClick", "icon"]),
                        _createVNode(_component_v_icon, {
                          onClick: ($event: any) => (openModalDelete(item.id, item.name)),
                          class: "hover:cursor-pointer",
                          color: "primary",
                          size: "small",
                          icon: _unref(mdiTrashCan)
                        }, null, 8, ["onClick", "icon"]),
                        _createVNode(_component_v_icon, {
                          "data-testid": "permissions-group-button-mobile",
                          onClick: ($event: any) => (openPermissionsModal(item)),
                          class: "hover:cursor-pointer",
                          color: "primary",
                          size: "small",
                          icon: _unref(mdiShieldAccount)
                        }, null, 8, ["onClick", "icon"])
                      ])
                    ])
                  ]))
                }), 128))
              : (_openBlock(), _createBlock(EmptyList, {
                  key: 1,
                  title: "Nenhum grupo encontrado",
                  class: "py-12"
                }))
          ]),
          (_unref(filteredGroups).length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                _createVNode(_component_v_pagination, {
                  modelValue: currentPage.value,
                  "onUpdate:modelValue": [
                    _cache[0] || (_cache[0] = ($event: any) => ((currentPage).value = $event)),
                    changePage
                  ],
                  "total-visible": 3,
                  length: pageCount.value,
                  density: "comfortable",
                  color: "primary"
                }, null, 8, ["modelValue", "length"])
              ]))
            : _createCommentVNode("", true)
        ], 64)),
    (_openBlock(), _createBlock(_Teleport, { to: "#app" }, [
      _createVNode(ConfirmDeleteModal, {
        onCloseModal: _cache[1] || (_cache[1] = ($event: any) => (showDeleteModal.value = false)),
        show: showDeleteModal.value,
        isLoading: isLoadingDelete.value,
        onHandleConfirm: handleDelete,
        description: `Você tem certeza que deseja excluir o grupo ${groupToDelete.value.name}?`
      }, null, 8, ["show", "isLoading", "description"]),
      _createVNode(UpdateGroupModal, { group: groupToUpdate.value }, null, 8, ["group"])
    ]))
  ]))
}
}

})